// import './SectionOurTools.scss';
// import React, { useEffect } from 'react';
// import img1 from '../../../assets/images/our1.png';
// import img2 from '../../../assets/images/our2.png';
// import img3 from '../../../assets/images/our3.png';
// import img4 from '../../../assets/images/our4.png';
// import img5 from '../../../assets/images/our5.png';
// import img6 from '../../../assets/images/our6.png';
// import { Col, Row } from 'antd';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import Aos from 'aos';

// const SectionOurTools = ({ t, data, isLoading }) => {
//   console.log(data, 'data from serve');

//   useEffect(() => {
//     Aos.init({
//       duration: 1000,
//     });
//   }, []);
//   return (
//     <div className="section-our-tools">
//       <div className="container">
//         <div className="content">
//           <h2 className="title-our-tools" data-aos="fade-right">
//             {t.OurTools}
//           </h2>
//           <div className="imgs-our">
//             <div className="group-img" data-aos="fade-up">
//               <Row gutter={[30, 30]} align="center">
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img1} alt="" />
//                 </Col>
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img2} alt="" />
//                 </Col>
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img3} alt="" />
//                 </Col>
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img4} alt="" />
//                 </Col>
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img5} alt="" />
//                 </Col>
//                 <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
//                   <img src={img6} alt="" />
//                 </Col>
//               </Row>
//             </div>
//           </div>
//           <div className="group-img-responsive">
//             <Swiper
//               spaceBetween={40}
//               slidesPerView={2.5}
//               scrollbar={{
//                 draggable: true,
//               }}
//             >
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img1} alt="" />
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img2} alt="" />
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img3} alt="" />
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img4} alt="" />
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img5} alt="" />
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="slider-img">
//                   <img src={img6} alt="" />
//                 </div>
//               </SwiperSlide>
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SectionOurTools;
import './SectionOurTools.scss';
import React, { useEffect } from 'react';
// إزالة استيراد الصور الثابتة، حيث ستأتي من البيانات
// import img1 from "../../../assets/images/our1.png";
// import img2 from "../../../assets/images/our2.png";
// import img3 from "../../../assets/images/our3.png";
// import img4 from "../../../assets/images/our4.png";
// import img5 from "../../../assets/images/our5.png";
// import img6 from "../../../assets/images/our6.png";
import { Col, Row, Skeleton } from 'antd'; // استيراد Skeleton
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Aos from 'aos';

const SectionOurTools = ({ t, data, isLoading }) => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  const LoadingToolCard = () => (
    <div className="tool-loading-card">
      <Skeleton.Image active style={{ width: '100%', height: '100px' }} />

      <Skeleton
        active
        paragraph={{ rows: 0 }}
        title={{ width: '70%', height: '18px' }}
        style={{ marginTop: '10px' }}
      />
    </div>
  );

  return (
    <div className="section-our-tools">
      <div className="container">
        <div className="content">
          <h2 className="title-our-tools" data-aos="fade-right">
            {/* {t.OurTools} */}
            Our Partners
          </h2>
          <div className="imgs-our">
            <div className="group-img" data-aos="fade-up">
              <Row gutter={[30, 30]} justify="center" align="middle">
                {isLoading
                  ? Array.from({ length: 6 }).map((_, index) => (
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        key={`loading-grid-${index}`}
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <LoadingToolCard />
                      </Col>
                    ))
                  : data
                      ?.sort((a, b) => a.order - b.order)
                      .map((tool, index) => (
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          lg={8}
                          xl={8}
                          xxl={8}
                          key={index}
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <div className="tool-item" style={{ textAlign: 'center' }}>
                            <img src={tool?.image} alt={tool?.name} />
                            {/* <p className="tool-name">{tool.name}</p>{' '} */}
                          </div>
                        </Col>
                      ))}
              </Row>
            </div>
          </div>
          <div className="group-img-responsive">
            <Swiper
              spaceBetween={40}
              slidesPerView={2.5}
              scrollbar={{
                draggable: true,
              }}
            >
              {isLoading
                ? // عرض بطاقات التحميل في Swiper
                  Array.from({ length: 6 }).map((_, index) => (
                    <SwiperSlide key={`loading-swiper-${index}`}>
                      <LoadingToolCard />
                    </SwiperSlide>
                  ))
                : // عرض البيانات الفعلية في Swiper بعد فرزها
                  data
                    ?.sort((a, b) => a.order - b.order)
                    .map((tool, index) => (
                      <SwiperSlide key={index}>
                        <div className="slider-img">
                          {' '}
                          {/* كلاس لستايل عنصر السلايدر */}
                          <img src={tool.image} alt={tool.name} />
                          <p className="tool-name">{tool.name}</p>{' '}
                          {/* عرض اسم الأداة */}
                        </div>
                      </SwiperSlide>
                    ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOurTools;
